import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { WattsLogo } from "@/components/WattsLogo";

export const Route = createFileRoute("/verify-email")({
  component: VerifyEmailPage,
});

function VerifyEmailPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [resending, setResending] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (cancelled) return;
      if (!session?.user) {
        navigate({ to: "/auth", replace: true });
        return;
      }
      setEmail(session.user.email ?? "");
      if (session.user.email_confirmed_at) {
        navigate({ to: "/map", replace: true });
      }
    };
    tick();
    const id = setInterval(tick, 3000);
    return () => { cancelled = true; clearInterval(id); };
  }, [navigate]);

  const resend = async () => {
    if (!email) return;
    setResending(true);
    const { error } = await supabase.auth.resend({
      type: "signup",
      email,
      options: { emailRedirectTo: `${window.location.origin}/map` },
    });
    setResending(false);
    if (error) toast.error(error.message);
    else toast.success("Email reenviado");
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0f0f0f] px-6 text-center fade-in">
      <WattsLogo width={160} />
      <div className="mt-10 flex h-20 w-20 items-center justify-center rounded-full bg-[#F5C518]/10">
        <Mail className="h-10 w-10 text-[#F5C518]" strokeWidth={1.8} />
      </div>
      <h1 className="mt-8 font-['Barlow_Condensed',sans-serif] text-4xl font-bold uppercase tracking-wide text-white">
        Revisa tu email
      </h1>
      <p className="mt-3 max-w-sm text-[14px] text-[#888]">
        Te hemos enviado un enlace de verificación a{" "}
        <span className="text-white">{email || "tu correo"}</span>
      </p>
      <button
        onClick={resend}
        disabled={resending}
        className="press-scale mt-8 rounded-xl border border-[#F5C518] px-6 py-3 text-sm font-bold text-[#F5C518] disabled:opacity-50"
      >
        {resending ? "Reenviando…" : "Reenviar email"}
      </button>
      <Link
        to="/auth"
        onClick={async (e) => { e.preventDefault(); await supabase.auth.signOut(); navigate({ to: "/auth", replace: true }); }}
        className="mt-5 text-xs text-[#666] underline"
      >
        ¿Email incorrecto? Vuelve atrás
      </Link>
    </div>
  );
}
